import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-finexs-privacy-policy',
  templateUrl: './finexs-privacy-policy.component.html',
  styleUrls: ['./finexs-privacy-policy.component.scss']
})
export class FinexsPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
